/* TodoPoer · ficha de producto: puntos del carrusel en celular. */
(function () {
  function bind(slider) {
    if (slider.dataset.tpDots) return;
    slider.dataset.tpDots = 'true';
    var dots = slider.querySelectorAll('.tp-dots__dot');
    if (!dots.length) return;
    slider.addEventListener('slideChanged', function (event) {
      var current = (event.detail && event.detail.currentPage) || 1;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === current - 1);
      }
    });
  }
  function init() {
    var sliders = document.querySelectorAll('slider-component[id^="GalleryViewer-"]');
    for (var i = 0; i < sliders.length; i++) bind(sliders[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
